import styles from "./authHeader.module.scss";
import appLogo from "../../../styles/pics/logo.png";
import { useSelector } from "react-redux";
import { LineChart, Line, ResponsiveContainer } from "recharts";
import { useHistory } from "react-router";
import { take } from "lodash";
import { showBetterPrice } from "../../../utils/showBetterPrice";
export default function AuthHeader() {
  const marketData = useSelector((state) => state.market?.data);
  const filteredCoins = marketData?.filter(
    (c) => c.symbol !== "USDT" && c.symbol !== "BNB" && c.symbol !== "USDC"
  );
  const takeJustThreeCoins = take(filteredCoins, 3);
  const history = useHistory();
  //Data for RechartJS
  const drawChart = (coin) => {
    return coin.klines.map((k) => ({ pv: k[1] }));
  };
  //
  return (
    <>
      <section className={styles.container}>
        <div className={styles.app_logo_container}>
          <img src={appLogo} alt="ArzFi" onClick={() => history.push("/")} />
        </div>
        <div className={styles.market_analyst_container}>
          {marketData &&
            takeJustThreeCoins.map((coin) => (
              <div className={styles.analyst_container} key={coin.symbol}>
                <div className={styles.crypto_icon}>
                  <img
                    src={`/images/assets-logo/${coin.symbol}.png`}
                    alt={coin.symbol}
                  />
                </div>
                <div className={styles.crypto_name_change_price}>
                  {coin.symbol}/{coin.percent_change_7d >= 0 ? "+" : ""}
                  {coin.percent_change_7d}
                </div>
                <div className={styles.crypto_price}>
                  ${showBetterPrice(coin.usdtPrice)}
                </div>
                <div className={styles.crypto_chart}>
                  {/* <ResponsiveContainer width="100%" height="100%"> */}
                  <LineChart width={97} height={200} data={drawChart(coin)}>
                    <Line
                      type="monotone"
                      dataKey="pv"
                      stroke="rgba(16, 208, 120, 0.42)"
                      strokeWidth={2}
                      dot={false}
                    />
                  </LineChart>
                  {/* </ResponsiveContainer> */}
                </div>
              </div>
            ))}
        </div>
        <div className={styles.balls_place}>
          <div className={`hiddenOfDarkMode ${styles.ball_gradient_1}`}></div>
          <div className={`hiddenOfDarkMode ${styles.ball_gradient_2}`}></div>
        </div>
      </section>
    </>
  );
}
